import React from 'react';
import { Box, Typography } from 'components/index';
import SimpleListCard from '../general/SimpleListCard';

const HelpText: React.FC = () => {
  return (
    <Box style={{ padding: 2 }}>
      <Typography variant='body2'>
        <b>Please make sure that the excel file being uploaded has:</b>
      </Typography>
      <ul>
        <li>
          <Typography variant='body2'>All the mandatory fields filled in.</Typography>
        </li>
        <li>
          <Typography variant='body2'>Correct values (from within the list of possible values) in all lookup/green fields.</Typography>
        </li>
        <li>
          <Typography variant='body2'>Numerical values in all numeric fields.</Typography>
        </li>
      </ul>
      <Typography variant='body2'>
        The excel upload will fail if any of the above criteria fails. We will provide a list of errors that caused the excel upload to
        fail. You can resubmit the excel for upload after making the required corrections to the sheet.
      </Typography>
      <br />
      <SimpleListCard
        heading='Mandatory Fields'
        list={['Project #', 'Project Name', 'Project City/State', 'Net Building Area']}
        itemsPerRow={2}
      />
      <br />
      <SimpleListCard
        heading='Lookup/Green Fields'
        list={[
          'Project Type',
          'Superstructure',
          'Roof',
          'HVAC Scope',
          'HVAC Type',
          'Plumbing',
          'Electrical',
          'Windows',
          'Construction Type',
          'Unique Cost Factors',
        ]}
        itemsPerRow={2}
      />
      <br />
      <SimpleListCard
        heading='Project Numeric Fields'
        list={['Monitoring Fee', 'Plan/Cost Fee', 'Site Area', 'Story Count', 'Building Count', 'Unit Count', 'Gross Building Area (sf)']}
        itemsPerRow={2}
      />
      <br />
      <SimpleListCard
        heading='Line Item Numeric Fields'
        list={['Original Budget', 'Reallocation', 'Change Order', 'Previous Application', 'Complete this period', 'Stored this period']}
        itemsPerRow={2}
      />
      <br />
    </Box>
  );
};

export default HelpText;
